import React from "react";
import {
  TestimonialAuthor,
  TestimonialBlockQuote,
  TestimonialFigure,
  TestimonialH5,
  TestimonialIcon,
  TestimonialSpan,
} from "./TestimonialCardStyle";

const TestimonialCard = ({
  reviewDesc,
  reviewAuthor,
  reviewAuthorTitle,
  reviewAuthorImage,
}) => {
  return (
    <TestimonialFigure>
      <TestimonialBlockQuote>{reviewDesc}</TestimonialBlockQuote>
      <TestimonialAuthor>
        <TestimonialIcon src={reviewAuthorImage} />
        <TestimonialH5>
          {reviewAuthor} <TestimonialSpan> {reviewAuthorTitle}</TestimonialSpan>
        </TestimonialH5>
      </TestimonialAuthor>
    </TestimonialFigure>
  );
};

export default TestimonialCard;
